var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-field',{ref:"loginFormCaptchInput",staticClass:"email-input font-medium",attrs:{"name":"email","placeholder":_vm.$t('login.login.loginForm.email.placeholder'),"autocomplete":"off","rules":_vm.rules},on:{"blur":_vm.emailBlurHandler},model:{value:(_vm.inputValue),callback:function ($$v) {_vm.inputValue=$$v},expression:"inputValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }